import React from 'react';
import { useTranslation } from 'react-i18next';
import { style } from 'typestyle';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import * as styles from './table-pagination.styles';

interface Props {
  readonly page: number;
  readonly pageCount: number;
  readonly onChangePage: (page: number) => void;
}

const TablePagination = ({ page, pageCount, onChangePage }: Props): React.JSX.Element | null => {
  const { t } = useTranslation();

  if (pageCount <= 1) {
    return null;
  }

  const isFirstPage = page === 0;
  const isLastPage = page >= pageCount - 1;

  return (
    <div className={style(styles.wrap)}>
      <button
        type="button"
        className={style(styles.navButton(isFirstPage))}
        disabled={isFirstPage}
        onClick={(): void => onChangePage(page - 1)}
        aria-label="previous page"
      >
        <ChevronLeftRoundedIcon fontSize="small" />
      </button>
      <span className={style(styles.label)}>
        {t('page')} {page + 1}/{pageCount}
      </span>
      <button
        type="button"
        className={style(styles.navButton(isLastPage))}
        disabled={isLastPage}
        onClick={(): void => onChangePage(page + 1)}
        aria-label="next page"
      >
        <ChevronRightRoundedIcon fontSize="small" />
      </button>
    </div>
  );
};

export default TablePagination;
